export default (state = [], action) => {
  switch (action.type) {
    case 'REQUEST_TEST_VOICES':
      return {
        ...state,
        isFetching: true,
      };
    case 'RECEIVE_TEST_VOICES':
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        failureFetching: false,
        test: {
          ...state.test,
          ...action.voices,
        },
      };
    case 'FAILURE_TEST_VOICES':
      return {
        ...state,
        failureFetching: true,
        isFetching: false,
        isFetched: false,
      };
    default:
      return state;
  }
};
